import {registerPlugin} from '@capacitor/core';

export interface CMMediaAccessOptions {
    filename: string;
    targetpath: string;
    saveToGallery?: boolean;
    quality?: number;
}

export interface CMMediaAccessResult {
    imageFile: string;
    filePath: string;
    error: boolean;
    errorMsg: string;
    compress?: boolean;
    saveToGallery?: boolean;
    bytes?: boolean;
    file?: boolean;
}

export interface CMMediaAccessResultObject {
    photos: Array<CMMediaAccessResult>;
}

export interface CMDeletLocalFileOptions {
    filename: string;
    dirname: string;
}

export interface CMFileUploadOptions {
    serverURL: string;
    params: CMFileUploadParams;
    filePath: string;
}

export interface CMFileUploadParams {
    apiID: string;
    sessionToken: string;
    osId: string;
    objId: string;
    fileName: string;
    fileAdd: number;
}

export interface HandleMediaAccess {
    getPictureFromCamera(options: CMMediaAccessOptions): Promise<CMMediaAccessResult>;

    getPictureFromGallery(options: CMMediaAccessOptions): Promise<CMMediaAccessResultObject>;

    getFileFromFilesApp(options: CMMediaAccessOptions): Promise<CMMediaAccessResult>;

    deleteLocalFile(options: CMDeletLocalFileOptions): Promise<boolean>;

    uploadFile(options: CMFileUploadOptions): Promise<any>;

    addListener(options: any, callback: any): Promise<any>;

    openAppSettings(): Promise<void>;
}

const cmHandleMediaAccess = registerPlugin<HandleMediaAccess>('CMHandleMediaAccess');
export default cmHandleMediaAccess;
